/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Hyväksy ja jatka',
    APPROVE: 'Hyväksy',
    CANCEL: 'Peruuta',
    SAVE: 'Tallenna'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'Olen lukenut ja hyväksyn käyttöehdot',
    ACCEPT_TERMS_DESCRIPTION:
      'Ennen kuin käytät Prozis Partnership -alustaa, lue ja hyväksy Prozis Influencer Program -käyttöehdot.',
    ACCEPT_TERMS_NAV_TITLE: 'Käyttöehdot',
    ACCEPT_TERMS_SCROLL_HINT: 'Lue loppuun asti jatkaaksesi.',
    DASHBOARD: 'Kojelauta',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Olemme huomanneet, että ilmoitukset eivät ole aktiivisia. Jotta voit jatkaa sovelluksen käyttöä, sinun on aktivoitava ilmoitukset.',
    ENABLE_NOTIFICATIONS_LINK: 'Voit aktivoida ilmoitukset täällä',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Ilmoitukset',
    ENABLE_NOTIFICATIONS_TITLE: 'Aktivoi ilmoitukset jatkaaksesi',
    HOME: 'Etusivu',
    INSTALL_PROZIS_APP: 'Asenna Prozis Store -sovellus',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Asenna mobiilisovelluksemme, jotta voit jatkaa kaikkien ominaisuuksien käyttöä.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Asenna sovellus',
    LOGOUT: 'Poistu',
    NOT_FOUND: 'Ei löydy',
    OR: 'Tai',
    OR_SCAN_QR_CODE: 'Tai skannaa QR-koodi',
    SCAN_QR_CODE: 'Skannaa QR-koodi mobiililaitteellasi',
    TODOS: 'Kaikki',
    UNAUTHORIZED_DESCRIPTION_1: 'Tarkista käyttöoikeudet esimieheltäsi.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Vahvistuksen jälkeen yritä kirjautua sisään uudelleen.',
    UNAUTHORIZED_NAV_TITLE: 'Pääsy evätty',
    UNAUTHORIZED_TITLE: 'Ei pääsyä'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
